// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectMethodsToValueQueryResult, selectMethodsToValuesPageLoading, selectMethodsToValuesShowInitWaitingMessage} from '../_selectors/methods-to-value.selectors';

export class MethodsToValuesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectMethodsToValuesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectMethodsToValuesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectMethodsToValueQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
